import { createTheme } from '@material-ui/core';
import { DefaultTheme } from 'styled-components';

import baseTheme from '@/theme';

/**
 * @deprecated
 * Use default export from `'@/themes/sleepioTheme'` instead.
 */
export const sleepioTheme: DefaultTheme = {
  checkBox: {
    backgroundColor: '#F1F9FF',
    color: '#163258',
  },
  infoBox: {
    backgroundColor: '#F1F9FF',
    textColor: '#163258',
  },
  link: {
    color: '#363334',
    fontWeight: 400,
  },
  button: {
    primary: {
      backgroundColor: '#FF8E75',
      disabledBackgroundColor: '#898989',
      textColor: '#163258',
      disabledTextColor: '#FFF',
    },
  },
  colors: {
    primaryNuetral: '#F7F6F5',
  },
};

export default createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    text: {
      primary: '#163258',
      secondary: '#6A717D',
    },
    primary: {
      light: '#F3A696',
      main: '#FF8E75',
      dark: '#FD6D53',
      contrastText: '#163258',
    },
    secondary: {
      light: '#234370',
      main: '#163258',
      dark: '#082143',
      contrastText: '#FFFFFF',
    },
  },
  overrides: {
    ...baseTheme.overrides,
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: '#163258',
        },
      },
    },
  },
});
